// Continuité du parcours démo → Scorecard → inscription → Discovery (sessionStorage, même onglet, jamais l'URL).
// Ne transporte QUE des données saisies par le visiteur ou déterminées par RegionService —
// jamais les chiffres du restaurant fictif de la démo.
export const JOURNEY = {
  scForm: 'cop_sc_form',        // brouillon du Scorecard (chiffres réels du visiteur)
  scPreview: 'cop_sc_preview',  // { preview_id, score, grade } du Scorecard calculé
  lead: 'cop_sc_lead',          // { email, name, restaurant_name } saisis par le visiteur
  demoStep: 'cop_demo_step',    // étape de la démo (bouton retour)
  shareSid: 'cop_share_sid',    // iter-122c — identifiant OPAQUE du lien partagé d'origine (jamais personnel)
  // iter-124 — résultat restaurable au refresh / retour : { preview, step, delivery, leadCaptured, saved_at } —
  // chiffres du restaurant + état d'envoi (identifiant opaque), jamais l'e-mail ; expire après SC_RESULT_TTL_MS.
  scResult: 'cop_sc_result',
};

export const SC_RESULT_TTL_MS = 24 * 60 * 60 * 1000;

// Événements émis une seule fois par session (aucun double comptage).
export const ONCE = {
  actionApproved: 'cop_demo_action_approved',
  scStarted: 'cop_sc_started',
  scCompleted: 'cop_sc_completed',
  // iter-122c — viralité : origine partagée + Scorecard commencé/terminé depuis un partage + fenêtre ouverte
  shareOrigin: 'cop_share_origin',
  shareScStarted: 'cop_share_sc_started',
  shareScCompleted: 'cop_share_sc_completed',
  shareOpened: 'cop_share_opened',
};

export const journey = {
  get(key) {
    try { const v = sessionStorage.getItem(key); return v ? JSON.parse(v) : null; } catch { return null; }
  },
  set(key, value) {
    try { sessionStorage.setItem(key, JSON.stringify(value)); } catch { /* ignore */ }
  },
  clear(...keys) {
    keys.forEach((k) => { try { sessionStorage.removeItem(k); } catch { /* ignore */ } });
  },
};
